import StartKickOff from "../../../../football/rules/general/start-kick-off";
import { isKickoffEnabled } from "../../../../football/utils/context-utils";

/**
 * Arms the opening kickoff, but only when the crew has opted in.
 *
 * Kickoffs are off by default in flag football, and configs saved before the
 * key existed lack it entirely, so an absent key must leave the game with no
 * kickoff - the truthy check handles both.
 */
export default class FlagStartKickOff extends StartKickOff {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return isKickoffEnabled(gameContext);
    }
}
